import { colors } from '@scouts/ui'

import { PATH_PROFILE_SUBSCRIPTIONS_HASH_BOOKKEEPING, PATH_PROFILE_SUBSCRIPTIONS_HASH_PHONE_SUPPORT } from '@/constants'
import {
    SubscriptionTiers,
    SubscriptionTierDetails,
    SubscriptionTierDetailsByVersion,
    SubscriptionTierType,
    SubscriptionTierVersion,
    SubscriptionTierVersions,
} from '@/models'

export const SUBSCRIPTION_TIER_DETAILS = {
    [SubscriptionTierVersions.Original]: [
        {
            tier: SubscriptionTierType.Pro,
            title: 'Pack Pro',
            name: 'Pro',
            description: 'Todo lo que necesitas para empezar',
            color: colors.surface.note,
            includes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Respuesta a todas tus dudas en 24 horas',
                'Alta de autónomo en Hacienda y en la Seguridad Social',
                'Alta en el ROI y gestión IVA intracomunitario, para que puedas facturar a clientes extranjeros',
                'Presentación de los impuestos de autónomos trimestrales y anuales',
                'Declaración de la renta',
            ],
        },
        {
            tier: SubscriptionTierType.Premium,
            title: 'Pack Premium',
            name: 'Premium',
            description: 'Deja el papeleo en manos de tu asesor',
            color: colors.surface.highlight,
            extra: ' todos los servicios del Pro',
            includes: [
                'Gestión de la contabilidad a cargo de tu asesor, solo tienes que subir tus facturas',
                'Contacto telefónico ilimitado con tu asesor. Resuelve tus dudas en una llamada',
                'Revisión trimestral con tu asesor para mejorar tu situación fiscal y que ahorres más',
            ],
            includesHashHighlight: [
                PATH_PROFILE_SUBSCRIPTIONS_HASH_BOOKKEEPING,
                PATH_PROFILE_SUBSCRIPTIONS_HASH_PHONE_SUPPORT,
            ],
        },
        {
            tier: SubscriptionTierType.Total,
            title: 'Pack Total',
            name: 'Total',
            description: 'Olvídate de absolutamente todo',
            color: colors.surface.accent,
            extra: ' todos los servicios del Premium',
            includes: [
                'Obtención del certificado digital',
                'Nos encargamos de todos tus trámites en Hacienda y la Seguridad Social, y monitorizamos y gestionamos las notificaciones que recibas',
                'Nos encargamos de todos los trámites para la contratación de hasta 3 empleados',
                'Declaración de la renta de tu pareja',
                'Te ayudamos a solicitar ayudas y subvenciones',
            ],
        },
        {
            tier: SubscriptionTierType.Companies,
            title: 'Pack Empresas',
            name: 'Empresas',
            description: '',
            color: colors.surface.note,
            extra: '',
            includes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (precio a ajustar en base al volumen de facturas)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
        },
    ],
    [SubscriptionTierVersions.March2024]: [
        {
            tier: SubscriptionTierType.Companies,
            title: 'Pack Empresas',
            name: 'Empresas',
            description: '',
            color: colors.surface.note,
            extra: '',
            includes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (precio a ajustar en base al volumen de facturas)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
        },
    ],
    [SubscriptionTierVersions.April2024]: [
        {
            tier: SubscriptionTierType.Pro,
            title: 'Pack Pro',
            name: 'Pro',
            description: 'Todo lo que necesitas para empezar',
            color: colors.surface.note,
            includes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Respuesta a todas tus dudas en 24 horas',
                'Alta de autónomo en Hacienda y en la Seguridad Social',
                'Alta en el ROI y gestión IVA intracomunitario, para que puedas facturar a clientes extranjeros',
                'Presentación de los impuestos de autónomos trimestrales y anuales',
                'Declaración de la renta',
            ],
        },
        {
            tier: SubscriptionTierType.Premium,
            title: 'Pack Premium',
            name: 'Premium',
            description: 'Deja el papeleo en manos de tu asesor',
            color: colors.surface.highlight,
            extra: ' todos los servicios del Pro',
            includes: [
                'Gestión de la contabilidad a cargo de tu asesor, solo tienes que subir tus facturas',
                'Contacto telefónico ilimitado con tu asesor. Resuelve tus dudas en una llamada',
                'Revisión trimestral con tu asesor para mejorar tu situación fiscal y que ahorres más',
            ],
            includesHashHighlight: [
                PATH_PROFILE_SUBSCRIPTIONS_HASH_BOOKKEEPING,
                PATH_PROFILE_SUBSCRIPTIONS_HASH_PHONE_SUPPORT,
            ],
        },
        {
            tier: SubscriptionTierType.Total,
            title: 'Pack Total',
            name: 'Total',
            description: 'Olvídate de absolutamente todo',
            color: colors.surface.accent,
            extra: ' el pack Premium',
            listTitle: 'El papeleo para contratar hasta 3 empleados',
            includes: [
                'Alta y contratación de los empleados',
                'Gestión de las nóminas',
                'Pagos de impuestos a Hacienda y a la Seguridad Social',
                'Bajas laborales',
                'Trámites de despido',
            ],
        },
        {
            tier: SubscriptionTierType.Companies10,
            title: 'Pack Empresas',
            name: 'Empresas 10',
            description: '',
            color: colors.surface.highlight,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 10 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 10 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies50,
            title: 'Pack Empresas',
            name: 'Empresas 50',
            description: '',
            color: colors.surface.affirm,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 50 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 50 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies200,
            title: 'Pack Empresas',
            name: 'Empresas 200',
            description: '',
            color: colors.surface.accent,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 200 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 200 facturas al mes)'],
        },
    ],
    [SubscriptionTierVersions.Feb2025]: [
        {
            tier: SubscriptionTierType.Companies10,
            title: 'Pack Empresas',
            name: 'Empresas 10',
            description: '',
            color: colors.surface.highlight,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 10 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 10 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies20,
            title: 'Pack Empresas',
            name: 'Empresas 20',
            description: '',
            color: colors.surface.affirm,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 20 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 20 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies50,
            title: 'Pack Empresas',
            name: 'Empresas 50',
            description: '',
            color: colors.surface.accent,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 50 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 50 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies100,
            title: 'Pack Empresas',
            name: 'Empresas 100',
            description: '',
            color: colors.surface.neutral,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 100 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 100 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies200,
            title: 'Pack Empresas',
            name: 'Empresas 200',
            description: '',
            color: colors.surface.note,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 200 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 200 facturas al mes)'],
        },
    ],
    [SubscriptionTierVersions.Oct2025]: [
        {
            tier: SubscriptionTierType.Companies20,
            title: 'Pack Empresas',
            name: 'Empresas 20',
            description: '',
            color: colors.surface.affirm,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 20 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 20 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies50,
            title: 'Pack Empresas',
            name: 'Empresas 50',
            description: '',
            color: colors.surface.accent,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 50 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 50 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies100,
            title: 'Pack Empresas',
            name: 'Empresas 100',
            description: '',
            color: colors.surface.neutral,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 100 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 100 facturas al mes)'],
        },
        {
            tier: SubscriptionTierType.Companies200,
            title: 'Pack Empresas',
            name: 'Empresas 200',
            description: '',
            color: colors.surface.note,
            extra: '',
            fullIncludes: [
                'Asesor fiscal personal',
                'Plataforma de facturación y gastos',
                'Contabilidad (hasta 200 facturas al mes)',
                'Contacto teléfonico con tu asesor. Resuelve tus dudas en una llamada',
                'Presentación de impuestos trimestrales y anuales',
                'Impuesto de Sociedades',
                'Legalización de libros y depósito de cuentas',
            ],
            includes: ['Todo lo que tienes ahora', 'Contabilidad (hasta 200 facturas al mes)'],
        },
    ],
}

/**
 * Gets the details of a subscription tier based on 3 criteria: a list of tier details (ordered by version), the subscription tier and its version
 */
export const getSubscriptionTierDetails = ({
    currentTierVersion,
    subscriptionTier,
    subscriptionTiersDetails,
}: {
    currentTierVersion: SubscriptionTierVersion
    subscriptionTier: SubscriptionTiers
    subscriptionTiersDetails: SubscriptionTierDetailsByVersion
}) => {
    const tierDetails = subscriptionTiersDetails[currentTierVersion]?.find((tier) => tier.tier === subscriptionTier)

    return tierDetails
}

/**
 * Retrieves the title of a subscription tier based on its type and title.
 * If the subscription tier type is not specified or set to 'None', it returns a default title.
 * Otherwise, it returns the provided title.
 */
export const getSubscriptionTierTitle = ({
    subscriptionTierType,
    tierDetails,
}: {
    subscriptionTierType: SubscriptionTiers
    tierDetails: SubscriptionTierDetails
}) => {
    const tierTitle =
        !subscriptionTierType || subscriptionTierType === SubscriptionTierType.None
            ? 'Personalizado'
            : tierDetails.title

    return tierTitle
}

export const getPreviousSubscriptionTier = (currentTier: SubscriptionTiers) => {
    const previousTierMap: Partial<Record<SubscriptionTiers, SubscriptionTiers>> = {
        [SubscriptionTierType.Total]: SubscriptionTierType.Premium,
        [SubscriptionTierType.Premium]: SubscriptionTierType.Pro,

        [SubscriptionTierType.Companies200]: SubscriptionTierType.Companies100,
        [SubscriptionTierType.Companies100]: SubscriptionTierType.Companies50,
        [SubscriptionTierType.Companies50]: SubscriptionTierType.Companies20,
        [SubscriptionTierType.Companies20]: SubscriptionTierType.Companies10,
    }

    return previousTierMap[currentTier]
}
